
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/koin-shop",
      function () {
        return require("private-next-pages/koin-shop.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/koin-shop"])
      });
    }
  